import React from "react";
import Fonts from "../../../../Config/Fonts";
import Icons from "../../../../Config/Images";
import { orderStatus } from "../../../../Constants/AppConstants";
import Colors from "../../../../theme/Colors";
import { formatDate } from "../../../../Utils";

const OrderTableBody = ({
  orderData,
  onViewOrderDetails,
  handleShowDeleteModal,
  onEditOrderDetails,
  onViewBtnShow,
  onEditBtnShow,
  onDeleteBtnShow,
}) => {

  return (
    <tbody>
      {orderData?.map((order, index) => (
        <tr key={index}>
          <td style={tableDataInputStyle} align="left">
            {index + 1}
          </td>
          <td style={tableDataInputStyle} align="left">
            {`${order?.shipping_address?.first_name} ${order?.shipping_address?.last_name}` ||
              "-"}
          </td>
          <td style={tableDataInputStyle} align="left">
            {order?.shop_name}
          </td>
          <td style={tableDataInputStyle} align="left">
            {order?.brand_name || "-"}
          </td>
          <td style={tableDataInputStyle} align="left">
            {order?.order_number || "-"}
          </td>
          <td style={tableDataInputStyle} align="left">
            {formatDate(order?.order_date)}
          </td>
          <td style={tableDataInputStyle} align="left">
            {order?.total_amount || "-"}
          </td>
          <td style={tableDataInputStyle} align="left">
            <div
              style={{
                color: orderStatus[order?.order_status_id]?.color || "#e0e0e0",
                padding: "7px 5px",
                borderRadius: "4px",
                textAlign: "center",
              }}
            >
              {orderStatus[order?.order_status_id]?.label || "Unknown"}
            </div>
          </td>
          <td align="right" style={tableDataInputStyle}>
            {onViewBtnShow==false && (
              <img
                src={Icons.viewIcon}
                style={{ height: "15px", width: "15px", cursor: "pointer" }}
                onClick={() => onViewOrderDetails(order)}
                alt="Preview Icon"
              />
            )}
            {onEditBtnShow==false && (
              <img
                src={Icons.editIcon}
                style={{
                  height: "15px",
                  width: "15px",
                  cursor: "pointer",
                  marginLeft: "15px",
                }}
                onClick={() => onEditOrderDetails(order)}
                alt="Edit Icon"
              />
            )}
            {onDeleteBtnShow==false && (
              <img
                src={Icons.trashIcon}
                style={{
                  height: "15px",
                  width: "15px",
                  cursor: "pointer",
                  marginLeft: "15px",
                }}
                onClick={() => handleShowDeleteModal(order?.user_id)}
                alt="Delete Icon"
              />
            )}
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default OrderTableBody;
